import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@services/translate.service';
import { ApiService } from '@app/services/api.service';
import { LocalizationService } from '@app/services/localization.service';
import { UiHelper } from '@helpers/ui.helper';

export interface ICasinoRegData {
  BirthPlaceCity: string;
  BirthplaceCountry: string;
  Gender: string;
  Email: string;
  PhoneNumber: string;
  Success: string;
}

@Component({
  selector: 'casino-register-modal',
  templateUrl: '../sharedTemplates/casino-register-modal.html',
})
export class CasinoRegisterModal {
  casinoRegisterDatas: UntypedFormGroup;
  BirthPlaceCityDisabled = false;
  EmailDisabled = false;
  BirthplaceCountryDisabled = false;
  constructor(
    private _ApiService: ApiService,
    private _FormBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CasinoRegisterModal>,
    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,

    @Inject(MAT_DIALOG_DATA) public data: ICasinoRegData
  ) {
    this._UiHelper.closeAllMenus();
    this.casinoRegisterDatas = _FormBuilder.group({
      eMail: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2), Validators.email]),
      birthPlace: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
      Phonecodeid: new UntypedFormControl({ value: '', disabled: false }, [Validators.minLength(2)]),
      PhoneNumber: new UntypedFormControl({ value: '', disabled: false }, []),
      country: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
    });
    this.getComboPhoneNumberList();
    this.setForm();
  }

  saveCasinoRegister() {
    this._ApiService.saveCasinoRegister(this.casinoRegisterDatas.value).then(result => {
      if (result && result.Success) {
        const t_message = this._TranslateService.instant('Register_Success');
        this._UiHelper.successSnackBar(t_message, '');
        this.dialogRef.close();
      } else {
        this._UiHelper.errorSnackBar(result.Message, '');
      }
    });
  }
  PhoneNumberList = [];
  getComboPhoneNumberList() {
    this._ApiService.getComboPhoneNumberList().then(PhoneNumberList => {
      this.PhoneNumberList = PhoneNumberList;
    });
  }
  setForm() {
    if (this.data.BirthPlaceCity) {
      this.casinoRegisterDatas.controls.birthPlace.setValue(this.data.BirthPlaceCity);
      this.BirthPlaceCityDisabled = true;
    }
    if (this.data.Email) {
      this.casinoRegisterDatas.controls.eMail.setValue(this.data.Email);
      this.EmailDisabled = true;
    }
    if (this.data.PhoneNumber) {
      this.casinoRegisterDatas.controls.PhoneNumber.setValue(this.data.PhoneNumber);
    }
    if (this.data.BirthplaceCountry) {
      this.casinoRegisterDatas.controls.country.setValue(this.data.BirthplaceCountry);
      this.BirthplaceCountryDisabled = true;
    }
    this.casinoRegisterDatas.controls.Phonecodeid.setValue(45);
  }
}
